import type { RouteRecordRaw } from 'vue-router';
import { jobIsAvailableRouteGuard } from '@apps/customer/routeGuards';

export const GALLERY_HUB_PAGE = 'customer-gallery-hub';
export const SELECT_PACKAGE_PAGE = 'customer-select-package';
export const SELECT_PACKAGE_DETAILS_PAGE = 'customer-package-details';
export const EDIT_CART_PACKAGE = 'customer-edit-cart-package';
export const CONSUMER_REVIEW_PAGE = 'customer-consumer-review';

const routes: RouteRecordRaw[] = [
  {
    path: ':jobId',
    children: [
      {
        path: 'subject/:subjectId',
        children: [
          {
            // RSPO hosted gallery hub: shows the subject's photos and lets the consumer pick the
            // one to "order with" (the anchor). Entry point before package selection.
            name: GALLERY_HUB_PAGE,
            path: 'gallery',
            component: () => import('./pages/GalleryHub/GalleryHubPage.vue'),
            beforeEnter: [jobIsAvailableRouteGuard],
          },
          {
            name: SELECT_PACKAGE_PAGE,
            path: 'select-package/:imageId?',
            component: () => import('./pages/SelectPackage/SelectPackagePage.vue'),
            beforeEnter: [jobIsAvailableRouteGuard],
          },
          {
            name: SELECT_PACKAGE_DETAILS_PAGE,
            path: 'package-options/:packageIDs/:imageId?',
            component: () => import('./pages/PackageOptions/SelectPackageOptionsPage.vue'),
            beforeEnter: [jobIsAvailableRouteGuard],
          },
        ],
      },
      {
        name: EDIT_CART_PACKAGE,
        path: 'edit-cart-package/:cartPackageId',
        component: () => import('./pages/PackageOptions/EditCartPackage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        // Consumer review of a cart the studio built for them (Cart Finalizing = Consumer): the whole
        // cart on one page, reached only through the emailed link. No availability guard on purpose:
        // the review window governs access here, not the job's prepay/gallery open dates.
        name: CONSUMER_REVIEW_PAGE,
        path: 'review',
        component: () => import('./pages/ConsumerReview/ConsumerReviewPage.vue'),
      },
    ],
  },
];

export default routes;
